import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DashboardServiceService } from '../../services/dashboard-service.service';

@Component({
  selector: 'app-remove-collaboratos',
  templateUrl: './remove-collaboratos.component.html',
  styleUrls: ['./remove-collaboratos.component.css'],
})
export class RemoveCollaboratosComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private dashboard: DashboardServiceService
  ) {
    //
  }

  ngOnInit(): void {
    //modal appear when to remove collaborator
  }

  cancel(): void {
    this.dashboard.callApi = false;
    this.dialog.closeAll();
  }

  submit(): void {
    this.dashboard.callApi = true;
    this.dialog.closeAll();
  }
}
